import React from 'react';
import { useI18n } from '../i18n/I18nContext';

function LanguageSwitcher({ style = {} }) {
  const { locale, setLocale, availableLocales } = useI18n();

  return (
    <select
      value={locale}
      onChange={(e) => setLocale(e.target.value)}
      style={{
        padding: '4px 8px',
        borderRadius: '4px',
        border: '1px solid rgba(255,255,255,0.3)',
        background: 'rgba(255,255,255,0.1)',
        color: 'inherit',
        fontSize: '13px',
        cursor: 'pointer',
        ...style
      }}
    >
      {availableLocales.map(l => (
        <option key={l} value={l} style={{ color: '#000' }}>
          {l === 'en' ? 'EN' : 'TH'}
        </option>
      ))}
    </select>
  );
}

export default LanguageSwitcher;
